import { Component, OnInit, Inject } from "@angular/core";
import { MediaObserver } from "@angular/flex-layout";
import { MAT_DIALOG_DATA, MatDialog, MatDialogConfig, MatDialogRef } from "@angular/material/dialog";
import { TranslateService } from "@ngx-translate/core";
import * as moment from "moment";
import { Observable, fromEvent } from "rxjs";
// import { ProductService } from "src/app/services/api/product/product.service";
import { SalemethodService } from "src/app/services/api/salemethod/salemethod.service";
import { ClientOrdersService } from "src/app/services/apiclient/order/clientorders.service";
import { CssService } from "src/app/services/css-service";
import { ToolsService } from "src/app/services/tools/tools.service";
import { AlertExpireDateProductDialogComponent } from "../../alert-expire-date-product-dialog/alert-expire-date-product-dialog.component";
import { AlertInvalidPricePeriodComponent } from "../../alert-invalid-price-period/alert-invalid-price-period.component";
import { checkLimitSlotDataType, validSlot, validSlots } from "./fulle-select-products-time-slot.interface";
import { PointOfSaleDayTimetable, PointOfSaleDetails } from "src/app/services/api/fulle/fulle-pointOfSale/fulle-pointOfSale.service.interface";
import { FulleProductService } from "src/app/services/api/fulle/fulle-product/fulle-product.service";

/**
 * Enumération pour définir les modes d'ouverture.
 */
enum CheckOpenMode {
  CalendarOnly,
  Full
}

/**
 * Composant pour sélectionner des créneaux horaires pour les produits.
 *
 * Ce composant gère la sélection des dates et des heures disponibles pour commander des produits.
 * Il interagit avec plusieurs services API pour récupérer les horaires valides et vérifier la disponibilité.
 */
@Component({
  selector: 'app-select-products-time-slot',
  templateUrl: './fulle-select-products-time-slot.component.html',
})
export class FulleSelectProductsTimeSlotComponent implements OnInit {

  // Observable qui écoute les événements de redimensionnement de la fenêtre.
  eventHeight: Observable<any> = fromEvent(window, "resize");

  // Hauteur interne de la fenêtre utilisée pour le calcul de disposition.
  innerHeight: number = window.innerHeight;

  // Liste des périodes de fermeture récupérées.
  closings: any;

  // Propriété obsolète pour les heures d'ouverture
  // opening: any; (DEPRECATED)

  // Emplois du temps valides pour le point de vente.
  timetables: any;

  // Liste des heures actuellement disponibles.
  currHours: any = [];

  // Date actuelle sélectionnée ou utilisée pour l'affichage.
  currDate: any;

  // Heure actuelle sélectionnée ou utilisée pour l'affichage.
  currHour: any;

  // Autres paramètres relatifs au créneau horaire.
  slotParams: any;

  // Date minimum pour la sélection d'une date de commande.
  minDate = moment();

  // Indicateur indiquant si un décalage est nécessaire au changement de jour.
  gapNeeded: boolean = false;

  // Méthode de vente en cours.
  saleMethod: any = this.tools.getStor(SalemethodService.TAG_STORAGE);

  // Statut de chargement pour différentes sections de l'application.
  loaders: any = {
    page: false,
    hours: false,
    dates: false
  }

  // Indicateur si fermée pour la journée.
  closedForToday: boolean = false;

  // Indique si un créneau horaire est défini.
  time_slot: boolean = false;

  // Indicateur pour savoir si l'initialisation est terminée.
  init = false;

  // Stocke les jours fermés pour afficher dans le calendrier.
  dateclosedForToday: any;

  // Gère la première date minimale configurable.
  setFirstMinDate: any;

  // Première date choisie dans le composant.
  Firstdate: any = null;

  // Jours actuellement fermés chargés depuis l'API.
  closedDays: any = [];

  // Indique si les jours fermés ont été chargés.
  daysClosedLoaded = false;

  // Constructeur de classe avec injection des services nécessaires.
  constructor(
    @Inject(MAT_DIALOG_DATA) data: any,
    private dialogRef: MatDialogRef<FulleSelectProductsTimeSlotComponent>,
    private dialog: MatDialog,
    public media: MediaObserver,
    private tools: ToolsService,
    public cssService: CssService,
    private orderApi: ClientOrdersService,
    private prodApi: FulleProductService,
    public translate: TranslateService
  ) {
    this.setFirstMinDate = data && data.firstOpen ? data.firstOpen : false;
  }

  /**
   * Méthode d'initialisation du composant.
   * Cette méthode est appelée automatiquement par Angular lorsqu'il crée ce composant pour la première fois.
   */
  ngOnInit() {
    // console.log("sm : ", this.saleMethod);
    this.initDatas();
  }

  /**
   * Initialise les données du composant.
   *
   * Récupère les informations de point de vente et de commande et configure l'état initial du composant.
   */
  initDatas() {
    const pointOfSale: PointOfSaleDetails = this.tools.getStor("point_of_sale");

    const dateOrder: any = this.tools.getStor("date_order");
    console.log("[TYPAGE] dateOrder: any : ", dateOrder);

    const hourOrder: any = this.tools.getStor("hour_order");
    console.log("[TYPAGE] hourOrder: any : ", hourOrder);

    this.closings = pointOfSale.closings;
    // this.opening = pointOfSale.opening; (DEPRECATED)
    this.timetables = pointOfSale.timetables;

    // Vérifique si une date de commande est déjà définie
    if (dateOrder) {
      this.currDate = moment(dateOrder);
      // Vérifie si l'heure choisie est après l'heure actuelle
      if (hourOrder && moment(hourOrder).isAfter(moment(), 'minute')) {
        this.currHour = moment(hourOrder).format("HH:mm");
      }
    }
    this.setDate(this.currHour);
    this.preloadDaysClosed();
  }

  /**
   * Pré-charge une liste de jours fermés à partir de l'API.
   *
   * Cette méthode est utilisée pour mettre à jour la liste des jours où le point de vente est fermé.
   * @private
   */
  private preloadDaysClosed(): void {
    this.daysClosedLoaded = false;
    const refDate = this.currDate ? moment(this.currDate) : moment(this.minDate);

    this.orderApi.getValidSlots(refDate).then((data: validSlots) => {
      this.closedDays = data?.daysclosed ? data.daysclosed : [];
    }).finally(() => {
      this.daysClosedLoaded = true;

      // Trick Angular Material: rebinder la fonction pour forcer le recalcul
      this.filterDate = (date: moment.Moment | null): boolean => {
        if (!date) return false;
        const min = this.minDate ? moment(this.minDate) : moment();
        if (date.isBefore(min, 'day')) {
          return false;
        }
        return this.checkOpenedDate(date, CheckOpenMode.CalendarOnly);
      };
    });
  }

  /**
   * Définit la date et éventuellement l'heure et modifie les heures disponibles.
   *
   * @param currHour Heure actuelle pour le contexte.
   */
  setDate(currHour?: any): void {
    console.log("[TYPAGE] setDate(currHour?: any) : ", currHour);

    if (!currHour) {
      this.removeHour();
    }
    this.changeHours();
  }

  /**
   * Vérifie si une date donnée est ouverte selon le mode spécifié.
   *
   * @param currMoment Moment à vérifier pour l'ouverture.
   * @param mode Mode d'ouverture à vérifier.
   * @returns boolean Indique si la date est ouverte ou non.
   */
  checkOpenedDate(currMoment: moment.Moment, mode: CheckOpenMode = CheckOpenMode.Full): boolean {
    if (!currMoment) return false;
    let isOpen = true;

    // 1) Vérifie selon les emplois du temps
    this.timetables?.forEach((day: PointOfSaleDayTimetable) => {
      if (day.day === currMoment.day()) {
        isOpen = false;
      }
    });

    // 2) Vérifie selon les périodes de fermeture
    if (this.closings?.length && isOpen) {
      for (const period of this.closings) {
        if (currMoment.isBetween(period.close_from, period.close_to, 'day', '[]')) {
          isOpen = false;
          break;
        }
      }
    }

    // 3) Vérifie selon les jours fermés
    if (this.closedDays?.length && isOpen) {
      for (const period of this.closedDays) {
        if (currMoment.isBetween(period.DATE_FROM, period.DATE_TO, 'day', '[]')) {
          isOpen = false;
          break;
        }
      }
    }

    if (mode === CheckOpenMode.CalendarOnly) {
      return isOpen;
    }

    return isOpen;
  }

  // Filtre les dates selon leur ouverture (méthode bindée à Angular Material).
  filterDate = (date: moment.Moment | null): boolean => {
    if (!date) return false;
    const min = this.minDate ? moment(this.minDate) : moment();
    if (date.isBefore(min, 'day')) {
      return false;
    }
    return this.checkOpenedDate(date, CheckOpenMode.CalendarOnly);
  };

  // Supprime la date actuellement sélectionnée.
  removeDate() {
    this.currDate = null;
  }

  // Supprime l'heure actuellement sélectionnée.
  removeHour() {
    this.currHour = null;
  }

  /**
   * Met à jour les heures disponibles selon la date actuelle et l'état.
   *
   * Cette méthode interroge l'API pour obtenir les créneaux horaires valides pour la date donnée.
   */
  changeHours(): void {
    this.closedForToday = false;
    this.time_slot = false;
    this.currHours = [];
    this.loaders.hours = true;
    this.loaders.dates = true;
    this.loaders.page = true;
    this.currDate = this.currDate ? this.currDate : null;

    this.orderApi.getValidSlots(this.currDate)
      .then((data: validSlots) => {
        this.tools.removeStor("closedForToday");

        if (data?.code && data.code < 0) {
          this.tools.openSnackBar(data.message, "warn", 2000);
          this.closedForToday = true;
          this.tools.setStor("closedForToday", this.closedForToday);

          setTimeout(() => {
            this.tools.openSnackBar(
              this.translate.instant('selectproductstimeslotComponent.redirect'),
              "great",
              1000,
              "center"
            );
            if (this.tools.checkCurrentPage("product")) {
              setTimeout(() => window.location.reload(), 1000);
            }
            if (this.tools.checkCurrentPage("endorder")) {
              this.tools.goProductPage();
            }
          }, 2000);
          return;
        }

        const validHours = (data?.valid_slots ?? []).filter((h: validSlot) => {
          h.available
        });

        this.currHours = data?.valid_slots ?? [];
        this.closedDays = data?.daysclosed ?? [];

        if (data?.day_changed) {
          this.gapNeeded = true;
          this.currDate = moment(data.day_changed);

          if (this.setFirstMinDate) {
            this.tools.removeStor("mindateOrder");
            this.minDate = moment(data.day_changed);
            this.tools.setStor("mindateOrder", this.minDate);
            this.tools.setStor("date_order", this.currDate);
          }
          this.minDate = this.tools.getStor("mindateOrder");
        }

        if (this.currHours.length > 0) {
          if (!this.currHour) {
            if (validHours.length > 0 && validHours[0].available) {
              this.currHour = validHours[0].hour;

              if (this.setFirstMinDate) {
                this.tools.setStor("hour_order", moment(this.currHour, "HH:mm:ss"));
                this.prodApi.setobserGetProduct('true');
                this.Firstdate = this.currDate.format("DD/MM/YYYY") + ' ' + moment(this.currHour, "HH:mm:ss");
                this.setFirstMinDate = false;
              } else {
                this.prodApi.setobserGetProduct();
              }
            }
          } else {
            for (let a = 0; a < this.currHours.length; a++) {
              const hour = this.currHours[a];
              if (hour.hour === this.currHour) {
                if (!hour.available) {
                  this.removeHour();
                  if (validHours.length > 0 && validHours[0].available) {
                    this.currHour = validHours[0].hour;
                  }
                }
                break;
              }
            }
          }
        } else {
          this.closedForToday = true;
        }
      })
      .catch((err: any) => {
        console.error("getValidSlots failed:", err);
        this.tools.openSnackBar("Erreur réseau lors du chargement des créneaux.", "warn", 2500);
        this.closedForToday = true;
      })
      .finally(() => {
        this.loaders.page = false;
        this.loaders.hours = false;
        this.loaders.dates = false;
      });
  }

  /**
   * Ferme le dialogue en enregistrant ou en annulant les changements de produits.
   *
   * @param changeProducts Boolean pour indiquer si des modifications des produits doivent être enregistrées.
   */
  closeDial(changeProducts: boolean) {
    if (changeProducts && (!this.Firstdate || (this.Firstdate !== this.currDate.format("DD/MM/YYYY") + ' ' + moment(this.currHour, "HH:mm:ss")))) {
      const hour = moment(this.currDate.format("DD/MM/YYYY") + ' ' + this.currHour, 'DD/MM/YYYY HH:mm');
      const result = { day: this.currDate, hour: hour };

      this.loaders.page = true;

      this.orderApi.checkLimitSlot(this.currDate, hour)
        .then((data: checkLimitSlotDataType | any) => {
          console.log("[TYPAGE]  this.orderApi.checkLimitSlot(this.currDate, hour).then((data: any): ", data);
          // Je laisse le any en cas de polymorphisme
          if (data.code == -201) this.openAlertProductValidty(data);
          if (data.code === -75) this.openAlertPricePeriodDial(data, result);
          else this.dialogRef.close(result);
        })
        .catch((err: any) => {
          console.error("checkLimitSlot failed:", err);
          this.tools.openSnackBar("Erreur réseau lors de la validation du créneau.", "warn", 2500);
        })
        .finally(() => {
          this.loaders.page = false;
        });

      return;
    }

    this.loaders.page = false;
    if (this.closedForToday) {
      this.tools.removeStor(SalemethodService.TAG_STORAGE);
      if (this.tools.checkCurrentPage("product")) {
        this.tools.setStor("closedForToday", this.closedForToday);
        setTimeout(() => window.location.reload(), 1000);
      }
      if (this.tools.checkCurrentPage("endorder")) {
        this.tools.goProductPage();
      }
    }
    this.dialogRef.close();
  }

  /**
   * Ouvre une alerte pour les périodes de prix invalides.
   *
   * @param errPeriod Détails de l'erreur de période.
   * @param result Résultat des données à transmettre après confirmation.
   */
  openAlertPricePeriodDial(errPeriod: any, result: any) {
    console.log("[TYPAGE] errPeriod: any : ", errPeriod);
    console.log("[TYPAGE] result: any : ", result);

    const myConf = new MatDialogConfig();
    myConf.data = { errPeriod: errPeriod }
    this.media.isActive("xs") ? myConf.width = "100%" : myConf.width = "450px";
    const myDial = this.dialog.open(AlertInvalidPricePeriodComponent, myConf);
    myDial.afterClosed().subscribe(data => {
      if (data) {
        this.dialogRef.close(result);
      }
    })
  }

  // /**
  //  * Récupère les emplois du temps valides pour un point de vente donné selon la méthode de vente actuelle.
  //  *
  //  * @param pointOfSale Objet représentant le point de vente.
  //  * @returns Liste des emplois du temps valides.
  //  */
  // getValidTimeTables(pointOfSale: PointOfSaleDetails): PointOfSaleDayTimetable[] | undefined {
  //   let validTimeTables = pointOfSale.timetables;
  //   // if (pointOfSale.timetables_sm) {
  //   //   for (let index = 0; index < pointOfSale.timetables_sm.length; index++) {
  //   //     const timeTable = pointOfSale.timetables_sm[index];
  //   //     if (timeTable.id_sale_method === this.saleMethod.id) {
  //   //       validTimeTables = timeTable.timetables;
  //   //       break;
  //   //     }
  //   //   }
  //   // }
  //   return validTimeTables;
  // }

  /**
   * Ouvre une alerte pour la validation de la date de péremption du produit.
   *
   * @param errProductValidity Détails de l'erreur de validité du produit.
   */
  openAlertProductValidty(errProductValidity: any) {
    console.log("[TYPAGE] errProductValidity: any : ", errProductValidity);
    const myConf = new MatDialogConfig();
    myConf.data = { errProductValidity: errProductValidity }
    myConf.panelClass = "dialog-responsive"
    this.media.isActive("xs")
      ? (myConf.width = "100%")
      : (myConf.width = "550px");
    const myDial = this.dialog.open(AlertExpireDateProductDialogComponent, myConf);
    myDial.afterClosed().subscribe(data => {
      if (data) {
        this.dialogRef.close();
      }
    })
  }
}
